import { Component } from '@angular/core';
import { AlertService } from "../../_services/alert.service";
import { SettingsService } from "../../_services/settings.service";
import { CustomerMap } from "../../_models/crmStats";


@Component({
  selector: 'invoicing',
  templateUrl: 'invoicing.html'
})

export class InvoicingComponent {

  invoiceSettings = this.settings.invoiceSettings;
  errorToCheck: string = "";

  constructor(private alert: AlertService, private settings:SettingsService) {
    
  }
  check() {
    this.settings.pageSettings.running = true;
    this.settings.checkInvoiceErrors.subscribe(() => {
      this.settings.pageSettings.running = false;
    });
  }
  checkCRMEntry() {
    this.settings.pageSettings.running = true;
    this.settings.checkCRMEntry(this.errorToCheck).subscribe(() => {
      this.settings.pageSettings.running = false;
    });
  }
  //todo these should be on a customer map directive - copied from customers.ts
  edit(cus: CustomerMap) {
    if (cus.edit) {
      if (cus.CRMName == "" && cus.XeroName == "") {
        this.alert.error("Both fields needed please");
      }
      else {
        cus.edit = false;
        this.settings.updateCustomer(cus).subscribe((res) => {
          console.log(res);
        });
      }
    }
    else {
      cus.tempCRM = cus.CRMName;
      cus.tempXero = cus.XeroName;
      cus.edit = true;
    }
  }
  cancelCus(cus: CustomerMap) {
    cus.CRMName = cus.tempCRM;
    cus.XeroName = cus.tempXero;
    cus.edit = false;
  }
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/components/invoicing/invoicing.ts